<div class="col-md-12 mb-3" *ngIf="mode != 'view'">
  <ngx-file-drop class="box" dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)" multiple="true"
    accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" *ngIf="isContractEditPermission">
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
      <div class="icon">
        <a (click)="openFileSelector()">
          <ng-icon name="heroArrowUpTray"></ng-icon>
          Drag and Drop or Click to Upload</a>
      </div>
    </ng-template>
  </ngx-file-drop>
</div>

<div class="col-md-12 common-table-style">
  <mat-table [dataSource]="supportingDocSource" matSort (matSortChange)="customSortData($event)">
    <ng-container matColumnDef="Document Name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Document Name</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Uploaded By">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded By</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.createdBy }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Uploaded On">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded On</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.createdDate }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Action">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
      <mat-cell *matCellDef="let element" class="action">
        <a mat-button color="accent" disableRipple (click)="downloadSupportingDocument(element.supportingDocumentId)"
          matTooltip="Download Document {{ element.name }}" [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
          <mat-progress-spinner *ngIf="downloadLoading[element.supportingDocumentId]; else go" mode="indeterminate"
            color="accent" diameter="24"></mat-progress-spinner>
          <ng-template #go><ng-icon name="heroArrowDownTray"></ng-icon></ng-template>
        </a>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="supportingDocColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: supportingDocColumns"></mat-row>

  </mat-table>

  <ng-container *ngIf="dataLoading">
    <div class="skeleton-box">
      <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
    </div>
  </ng-container>

  <ng-container *ngIf="supportingDocSource.data.length === 0 && !dataLoading">
    <div class="no-data">
      <h4>No Data Found</h4>
      <p>There are no supporting documents available</p>
    </div>
  </ng-container>

  <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>

</div>